import { render, staticRenderFns } from "./BotPause.vue?vue&type=template&id=b8de8626&"
import script from "./BotPause.vue?vue&type=script&lang=js&"
export * from "./BotPause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports